module.exports = __webpack_public_path__ + "assets/img/6775433e6b652102f739749a9b5538be.webp";